import { createSlice, PayloadAction, Dispatch } from "@reduxjs/toolkit";
import { AgentService } from "app/services";
import { toggleQuickPanel } from "app/main/shared-components/quick-panel/store";
import { errorMsg, successMsg } from "app/utils/MessageUtils";
import { fetchAllAgents, fetchAllSubAgents } from "./agents-list.slice";
import { CreateAgentBodyTypes } from "app/types/service-types/AgentTypes";
import { getApiErrorMessage } from "app/utils/getApiErrorMessage";
import AuthService from "app/services/auth.service";
import {ROLES} from "app/constants/roles";

interface CreateAgentStateParams {
  body: CreateAgentBodyTypes;
  onSuccess?: () => void;
  onError?: () => void;
}

interface CreateAgentSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: CreateAgentSlice = {
  error: "",
  success: false,
  loading: false,
};

const stateSlice = createSlice({
  name: "agent/create-agent",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.success = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});

export const { setLoading, setSuccess, setError } = stateSlice.actions;
export default stateSlice.reducer;

const isUserAgent = (): boolean => {
  const user = AuthService.handleAuthentication();
  if (!user) return false;
  // @ts-ignore
  const authorities = user.authorities || [];
  const isAdmin = authorities.includes(ROLES.ROLE_ADMIN);
  const isAgent = authorities.includes(ROLES.ROLE_AGENT) && !isAdmin;
  return isAgent;
};

export const createAgent =
  (params: CreateAgentStateParams) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      await AgentService.createAgent(params.body);

      dispatch(setSuccess(true));
      dispatch(toggleQuickPanel());
      const isAgent = isUserAgent();
      const lang = localStorage.getItem("i18nextLng");
      const message = lang === "en"
        ? (isAgent ? "Sub-Agent added successfully!" : "Agent added successfully!")
        : (isAgent ? "Sub-Agjenti u shtua me sukses!" : "Agenti u shtua me sukses!");
      dispatch(successMsg(message));

      params.onSuccess?.();
      dispatch(setError(""));
      // @ts-ignore
      dispatch(isAgent ? fetchAllSubAgents() : fetchAllAgents());
    } catch (e) {
      const msg = getApiErrorMessage(e, "Something went wrong");
        dispatch(errorMsg(msg));
        dispatch(setError(msg));

      params.onError?.();
    } finally {
      dispatch(setLoading(false));
    }
  };



